import Footer from "../components/Footer";
import WhoWeAre from "../components/WhoWeAre";
import AboutIntro from "../components/AboutIntro";
import Seo from "../components/Seo";
import { URLS } from "../utils/constants";

const AboutUs = () => {
  const meta = URLS.about;

  return (
    <div className="about-page">
      <Seo title={meta.title} description={meta.desc} keywords={meta.keywords} image={meta.metaImage} path={meta.path} />
      <h1 className="visually-hidden">{meta.title}</h1>
      <AboutIntro />

      <WhoWeAre />

      <Footer />
    </div>
  );
};

export default AboutUs;
